import { LOCALE_REGEX as r } from "./help-center-articles-search19.js";
const o = (t) => {
  if (!t || !r.test(t))
    return "en-US";
  const e = t.split("-");
  return e && e.length === 2 ? `${e[0]?.toLowerCase()}-${e[1]?.toUpperCase()}` : t.toLowerCase();
};
export {
  o as normalizeLocale
};
//# sourceMappingURL=help-center-articles-search5.js.map
